import { useEffect, useState } from "react";
import api, { fmtMoney, fmtDate } from "@/lib/api";
import { PageHeader } from "@/components/shared/PageHeader";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2 } from "lucide-react";

const STATUS = { "Nouvelle": "bg-blue-500/15 text-blue-400", "Confirmée": "bg-emerald-500/15 text-emerald-400", "En préparation": "bg-amber-500/15 text-amber-400", "Expédiée": "bg-purple-500/15 text-purple-400", "Livrée": "bg-emerald-500/15 text-emerald-400", "Annulée": "bg-red-500/15 text-red-400" };

export default function CentralOrders() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/central/orders").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  return (
    <div>
      <PageHeader title="Commandes" subtitle="Toutes les commandes générées par les boutiques en ligne" />
      <div className="vp-card rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader><TableRow className="border-white/10 hover:bg-transparent">
              {["N°", "Boutique", "Client", "Montant", "Paiement", "Statut", "Date"].map((h) => <TableHead key={h} className="text-slate-400 text-xs uppercase tracking-wider">{h}</TableHead>)}
            </TableRow></TableHeader>
            <TableBody>
              {rows === null && <TableRow><TableCell colSpan={7} className="text-center py-10 text-slate-500"><Loader2 className="animate-spin inline mr-2" size={16} /> Chargement…</TableCell></TableRow>}
              {rows && rows.map((o) => (
                <TableRow key={o.id} className="border-white/5 hover:bg-white/[0.03]" data-testid="central-order-row">
                  <TableCell className="mono text-sm text-white">{o.number}</TableCell>
                  <TableCell className="text-slate-300 text-sm">{o.store_name}</TableCell>
                  <TableCell className="text-slate-300 text-sm">{o.customer_name}</TableCell>
                  <TableCell className="mono text-sm text-white">{fmtMoney(o.total)}</TableCell>
                  <TableCell className="text-slate-400 text-sm">{o.payment_method}</TableCell>
                  <TableCell><span className={`text-xs px-2 py-1 rounded-full ${STATUS[o.status] || "bg-slate-500/15 text-slate-400"}`}>{o.status}</span></TableCell>
                  <TableCell className="text-slate-400 text-sm">{fmtDate(o.created_at)}</TableCell>
                </TableRow>
              ))}
              {rows && rows.length === 0 && <TableRow><TableCell colSpan={7} className="text-center py-10 text-slate-500">Aucune commande</TableCell></TableRow>}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
